import { object } from 'yup';
import { IResetPasswordFormData } from '../../../domain/models/IResetPasswordFormData';
import { ITranslationFunction } from '../../../../../shared/i18n/translate';
import { createSignUpSchema } from '../../../../sign-up/domain/models/SignUpSchema';

export function createResetPasswordSchema(t: ITranslationFunction) {
	const signUpSchema = createSignUpSchema(t);

	return object<IResetPasswordFormData>({
		password: signUpSchema.fields.password,
		confirmPassword: signUpSchema.fields.confirmPassword,
	}).required();
}
